import { makeStyles } from "@material-ui/styles";

export default makeStyles(() => ({
  inputContainer: {
    width: "20rem",
  },
  link: {
    textDecoration: "none",
  },
  marginLeft: {
    marginLeft: ".29rem",
  },
  termsContainer: {
    "& > *": {
      marginRight: ".29rem",
    },
  },
}));
